"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialState = void 0;
const fp = require("fp-ts");
const monocle = require("monocle-ts");
const currentReducer = require("./current");
const forgotPasswordReducer = require("./forgotPassword");
const loginReducer = require("./login");
const oauth2Reducer = require("./oauth2");
const resetPasswordReducer = require("./resetPassword");
const zendeskReducer = require("./zendesk");
exports.initialState = {
    current: Object.assign({}, currentReducer.initialState),
    forgotPassword: Object.assign({}, forgotPasswordReducer.initialState),
    login: Object.assign({}, loginReducer.initialState),
    oauth2: Object.assign({}, oauth2Reducer.initialState),
    resetPassword: Object.assign({}, resetPasswordReducer.initialState),
    zendesk: Object.assign({}, zendeskReducer.initialState)
};
const currentLens = monocle.Lens.fromProp('current');
const forgotPasswordLens = monocle.Lens.fromProp('forgotPassword');
const loginLens = monocle.Lens.fromProp('login');
const oauth2Lens = monocle.Lens.fromProp('oauth2');
const resetPasswordLens = monocle.Lens.fromProp('resetPassword');
const zendeskLens = monocle.Lens.fromProp('zendesk');
// Current
const handleCurrent = (action) => (state) => {
    const fn = currentReducer.methods[action.type];
    if (fn) {
        const current = currentLens.get(state);
        return currentLens.set(fn(current, action))(state);
    }
    return state;
};
// Forgot password
const handleForgotPassword = (action) => (state) => {
    const fn = forgotPasswordReducer.methods[action.type];
    if (fn) {
        const current = forgotPasswordLens.get(state);
        return forgotPasswordLens.set(fn(current, action))(state);
    }
    return state;
};
// Login
const handleLogin = (action) => (state) => {
    const fn = loginReducer.methods[action.type];
    if (fn) {
        const current = loginLens.get(state);
        return loginLens.set(fn(current, action))(state);
    }
    return state;
};
// Oauth2
const handleOauth2 = (action) => (state) => {
    const fn = oauth2Reducer.methods[action.type];
    if (fn) {
        const current = oauth2Lens.get(state);
        return oauth2Lens.set(fn(current, action))(state);
    }
    return state;
};
// Reset Password
const handleResetPassword = (action) => (state) => {
    const fn = resetPasswordReducer.methods[action.type];
    if (fn) {
        const current = resetPasswordLens.get(state);
        return resetPasswordLens.set(fn(current, action))(state);
    }
    return state;
};
// Reset Password
const handleZendesk = (action) => (state) => {
    const fn = zendeskReducer.methods[action.type];
    if (fn) {
        const current = zendeskLens.get(state);
        return zendeskLens.set(fn(current, action))(state);
    }
    return state;
};
// Reducer
exports.default = (state = Object.assign({}, exports.initialState), action) => {
    return fp.function.compose(handleCurrent(action), handleForgotPassword(action), handleLogin(action), handleOauth2(action), handleResetPassword(action), handleZendesk(action))(state);
};
//#endregion
//# sourceMappingURL=index.js.map